/**
 * Query Collection Mapping Data
 *
 * Format:
 * {
 *   "food,foods": [
 *       { handle, title, url },
 *       ...
 *   ],
 *   "toys,dog-toys": [
 *       { handle, title, url },
 *       ...
 *   ]
 * }
 *
 * You just update the object below whenever you want to add new queries or collections.
 */

window.queryCollectionMappings = {};

// --- Main data: Add or update queries here ---
const collectionData = {
  "sunscreen": [
    { "title": "Photostable sunscreen" },
    { "title": "Invivo tested sunscreen" },
    { "title": "Spf 50 Sunscreen" }
  ],
  "face wash": [
    { "title": "Face wash for oily skin" },
    { "title": "face wash for dark spot" },
    { "title": "face wash for acne" }
  ],
  "lip balm": [
    { "title": "lip balm for dark lips" },
    { "title": "lip balm for pigmentation" }
  ],
  "lipbalm": [
    { "title": "lip balm for dark lips" },
    { "title": "lip balm for pigmentation" }
  ],
  "combo": [
    { "title": "Bestseller Combo" },
    { "title": "Anti Acne Skincare kit" },
    { "title": "Anti Pigmentation Skincare Kit" }
  ],
  "vitamin c": [
    { "title": "Vitamin c serum" },
    { "title": "Vitamin c face wash" },
    { "title": "Vitamin c sunscreen" }
  ],
  "lip": [
    { "title": "Lip balm" },
    { "title": "Lip balm for dark lips" },
    { "title": "Lip balm for pigmentation" }
  ],
  "moisturizer": [
    { "title": "moisturizer for Oily skin" },
    { "title": "moisturizer for summer" }
  ],
  "facewash": [
    { "title": "Face wash for oily skin" },
    { "title": "face wash for dark spot" },
    { "title": "face wash for acne" }
  ],
  "serum": [
    { "title": "Serum for dull and dry skin" },
    { "title": "Anti aging face serum" },
    { "title": "niacinamide face serum" }
  ],
  "vitamin c serum": [
    { "title": "vitamin c serum" },
    { "title": "Face serum with vitamin c" },
    { "title": "Vitamin c pigmentation serum" }
  ]
};

// --- Automatically populate the global mapping ---
for (const queries in collectionData) {
  queries.split(',').forEach(query => {
    window.queryCollectionMappings[query.toLowerCase().trim()] = collectionData[queries];
  });
}

// --- Helper function to get collections ---
window.getQueryCollections = function(query) {
  if (!query) return [];
  const key = query.toLowerCase().trim();
  return window.queryCollectionMappings[key] || [];
};

// Optional debug log

/**
 * Query Suggestions mappnig data
 *
 * Format:
 * {
 *   "food,foods": [
 *       { image, title, url },
 *       ...
 *   ],
 *   "toys,dog-toys": [
 *       { image, title, url },
 *       ...
 *   ]
 * }
 *
 * You just update the object below whenever you want to add new queries or suggestions.
 */

window.querySuggestionsMappings = {};

// --- Main data: Add or update queries here ---
const suggestionsData = {
  "food": [
    {
      image: "https://headsupfortails.com/cdn/shop/files/Sara_sWholesome-Chicken_Turkey1copy_2d681770-7916-4920-8908-7dd3f71b9159.jpg?v=1757397544",
      url: "https://headsupfortails.com/pages/saras",
      title: "Sara’s Wholesome Dog Food"
    },
    {
      image: "https://cdn.shopify.com/s/files/1/0086/0795/7054/files/das-logo.png?v=1681307139",
      url: "https://headsupfortails.com/pages/dashdog",
      title: "Hearty Dog Food"
    }
  ]
};

// --- Automatically populate the global mapping ---
for (const queries in suggestionsData) {
  queries.split(',').forEach(query => {
    window.querySuggestionsMappings[query.toLowerCase().trim()] = suggestionsData[queries];
  });
}

// --- Helper function to get collections ---
window.getQuerySuggestions = function(query) {
  if (!query) return [];
  const key = query.toLowerCase().trim();
  return window.querySuggestionsMappings[key] || [];
};

// Optional debug log